// extracted by mini-css-extract-plugin
module.exports = {"McsFooterBannerWrap":"McsFooterBannerBack_McsFooterBannerWrap__2xpV-","McsFooterBannerButton":"McsFooterBannerBack_McsFooterBannerButton__2YFGJ"};